// extracted by mini-css-extract-plugin
export default {"shimmer":"EmbeddedDefaultPaymentMethod_shimmer__loyv7"};